function parseOptionalDate(value: Date | string | undefined): Date | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}

export function shiftDateByDays(
  value: Date | string | undefined,
  days: number,
): Date | undefined {
  const date = parseOptionalDate(value);
  if (!date) {
    return undefined;
  }

  const shifted = new Date(date);
  shifted.setDate(shifted.getDate() + days);
  return shifted;
}

export function alignDateToTarget(
  value: Date | string | undefined,
  target: Date,
): Date {
  const date = parseOptionalDate(value) ?? new Date(target);
  const aligned = new Date(target);
  aligned.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), 0);
  return aligned;
}
